import { styled } from '@mui/material/styles';
import { Card, CardContent, Chip, Typography, type TypographyProps } from '@mui/material';
import { TURN_STYLES } from '@/styles/theme';

export const CardStyled = styled(Card)(({ theme }) => ({
  backgroundColor: 'transparent',

  ...(theme.palette.mode === 'light' && {
    border: 'none !important',
  }),

  ...(theme.palette.mode === 'dark' && {
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
  }),
}));

export const CardContentStyled = styled(CardContent)(() => ({
  paddingBottom: '16px !important',
}));

export const WorkerName = styled(Typography)<TypographyProps>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  lineHeight: 1.2,
  cursor: 'pointer',
}));

export const HeaderChip = styled(Chip)(({ theme }) => ({
  border: `1.5px solid ${theme.palette.divider}`,
}));

/** Filled chip for top-level FCRA `source` (Applicant Source; secondary accent), distinct from outlined ID / Turn ID chips */
export const HeaderChipSecondaryAccent = styled(Chip)(({ theme }) => ({
  border: 'none',
  fontWeight: 600,
  cursor: 'pointer',
  backgroundColor: TURN_STYLES.secondaryAccentColor,
  color: '#fff',
  '& .MuiChip-label': { px: 1.25 },
  // Override MuiChip-clickable default (action.hover gray) with blue-tinted hover
  '&.MuiChip-clickable:hover, &.MuiChip-clickable:focus-visible, &:hover': {
    backgroundColor: '#1565c0',
  },
  '&.MuiChip-clickable:active, &:active': {
    backgroundColor: '#0d47a1',
  },
  ...(theme.palette.mode === 'dark' && {
    backgroundColor: TURN_STYLES.darkSecondaryAccentColor,
    color: theme.palette.grey[900],
    '&.MuiChip-clickable:hover, &.MuiChip-clickable:focus-visible, &:hover': {
      backgroundColor: '#81d4fa',
    },
    '&.MuiChip-clickable:active, &:active': {
      backgroundColor: '#4fc3f7',
    },
  }),
}));
